module.exports = __webpack_public_path__ + "static/media/gmail.4ab86686.png";